import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Select from "../../../components/select/select";
import { useOptions } from "../../../components/hooks/useOptionsHook";
import Button from "../../../components/buttons/button";

const GeneralSettingsTab = ({ t }) => {
  const formik = useFormik({
    initialValues: {},
    onSubmit: (vals) => {
      console.log(vals);
    },
  });
  const { languageOptions, dateFormatOptions } = useOptions();

  return (
    <div className="space-y-4">
      <h2 className="text-lg font-medium text-mainGray">{t("clubInfo")}</h2>
      <form
        onSubmit={formik.handleSubmit}
        className="p-4 space-y-4 rounded-2xl bg-sideBar"
      >
        <div className="inputs">
          <TextInput label={t("clubName")} name={"name"} formik={formik} />
          <Select
            options={languageOptions}
            formik={formik}
            label={t("defaultLang")}
            name={"defaultLang"}
          />
        </div>
        <div className="inputs">
          <Select
            options={languageOptions}
            formik={formik}
            label={t("defaultCurrency")}
            name={"defaultCurrency"}
          />
          <Select
            options={dateFormatOptions}
            formik={formik}
            label={t("dateFormat")}
            name={"dateFormat"}
          />
        </div>
        <div className="inputs">
          <TextInput label={t("email")} name={"email"} formik={formik} />
          <TextInput label={t("phone")} name={"phone"} formik={formik} />
        </div>
        <Button className={"bg-primary flex justify-center text-black py-3"}>
          {t("save")}
        </Button>
      </form>
    </div>
  );
};

export default GeneralSettingsTab;
